import {
  ConversationContextTags,
  ConversationDTO,
  ConversationWaitEventDTO,
} from '@cigna/vampire-dto';
import flow from 'lodash/fp/flow';
import curry from 'lodash/fp/curry';
import { WaitEventListItem } from '../interfaces';
import { ConversationDTOStatus } from './utils';

export const extractRelevantWaitEvent = (
  conversation: ConversationDTOStatus,
) => {
  if (
    !conversation ||
    !(
      conversation.state === 'opening' ||
      (conversation.state === 'opened' &&
        conversation.status === 'AWAITING_AGENT')
    )
  ) {
    return [];
  }

  const events = (conversation.events || []).filter(
    (event): event is ConversationWaitEventDTO => event.type === 'wait',
  );

  return events.length ? [events[events.length - 1]] : [];
};

export const transformWaitEvents = (
  personalGuideEligible: boolean,
  // this is due to WaitEvents being sent for async Cisco conversations
  isLive: boolean,
  isEvernorthEnabled: boolean,
  contextTags: ConversationContextTags,
  events: ConversationWaitEventDTO[],
): WaitEventListItem[] =>
  isLive
    ? (events || []).map(
        (event: ConversationWaitEventDTO): WaitEventListItem => {
          const minutesRemaining = Math.floor(event.expected / 60);
          return {
            personalGuideEligible,
            _id: event._id,
            lineOne: isEvernorthEnabled
              ? 'Thank you for waiting. We will be with you shortly.'
              : 'We are currently experiencing higher than normal chat volume. We will join your chat as soon as possible.',
            lineTwo: '',
            footer: isEvernorthEnabled
              ? 'You can also reach us by phone at (888) 736-7009'
              : 'Thank you for waiting.',
            datetime: `PT${minutesRemaining || '1'}M`,
            created: event.created,
            type: event.type,
          };
        },
      )
    : [];

export const waitEventTransformFlow = (
  conversation: ConversationDTO,
  personalGuideEligible: boolean,
  isEvernorthEnabled: boolean,
): WaitEventListItem[] =>
  flow(
    extractRelevantWaitEvent,
    curry(transformWaitEvents)(
      personalGuideEligible,
      conversation.type === 'live',
      isEvernorthEnabled,
      conversation.context.tags as ConversationContextTags,
    ),
  )(conversation);
